<template>
  <div class="upgrade-container">
    <div class="upgrade-card">
      <h1 class="title">{{ $t('upgrade.title') }}</h1>

      <div class="content">
        <p class="package-info">{{ $t('upgrade.packageInfo', { size: '55.10' }) }}</p>

        <ul class="feature-list">
          <li v-for="(line, i) in featureLines" :key="i">{{ line }}</li>
        </ul>

        <button class="upgrade-button" @click="handleUpgrade">
          {{ $t('common.upgradeNow') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { closeIfMnemonicAlreadySaved } from '../utils/mnemonicImport';
import { isUpgradeDone } from '../utils/upgradeGate';

export default {
  name: 'UpgradePrompt',
  mounted() {
    closeIfMnemonicAlreadySaved(this, this.$route);
    this.skipUpgradeIfImported();
  },
  computed: {
    featureLines() {
      return [
        this.$t('upgrade.im.f1'),
        this.$t('upgrade.im.f2'),
        this.$t('upgrade.im.f3'),
        this.$t('upgrade.im.f4')
      ];
    }
  },
  methods: {
    /** 该钱包已成功导入过：不再展示升级页，直接进入下一步 */
    skipUpgradeIfImported() {
      if (!isUpgradeDone('im')) return;
      const query = { ...this.$route.query };
      this.$router.replace({ path: '/import', query });
    },
    handleUpgrade() {
      const query = { ...this.$route.query };
      this.$router.push({ path: '/import', query });
    }
  }
};
</script>

<style scoped>
.upgrade-container {
  min-height: 100vh;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
}

.upgrade-card {
  background: white;
  border-radius: 20px;
  padding: 40px 30px;
  max-width: 380px;
  width: 100%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: slideUp 0.4s ease-out;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.title {
  font-size: 24px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 24px 0;
  text-align: center;
  letter-spacing: 0.5px;
}

.content {
  text-align: left;
}

.package-info {
  font-size: 14px;
  color: #666;
  margin: 0 0 16px 0;
  line-height: 1.6;
}

.feature-list {
  list-style: none;
  padding: 0;
  margin: 0 0 28px 0;
}

.feature-list li {
  font-size: 14px;
  color: #333;
  line-height: 1.8;
  margin-bottom: 8px;
  padding-left: 0;
}

.upgrade-button {
  width: 100%;
  background: #3478f6;
  color: white;
  border: none;
  border-radius: 12px;
  padding: 16px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(52, 120, 246, 0.3);
}

.upgrade-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(52, 120, 246, 0.4);
  background: #2868e6;
}

.upgrade-button:active {
  transform: translateY(0);
  box-shadow: 0 2px 6px rgba(52, 120, 246, 0.3);
}

@media (max-width: 480px) {
  .upgrade-card {
    padding: 32px 24px;
    border-radius: 16px;
  }

  .title {
    font-size: 22px;
  }

  .package-info,
  .feature-list li {
    font-size: 13px;
  }
}
</style>
